/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateAccount = /* GraphQL */ `
  subscription UpdateAccount($PK: String!) {
    updateAccount(PK: $PK) {
      PK
      SK
      accountState
      deposit
      bonus
      withdrawable
      valute
      createdAt
      lastDepositDate
      weekTotal
      monthTotal
      depositLimit
      depositLimitPeriod
      pickedUp
      expenses
      updatedAt
      winnings
    }
  }
`;
export const onWinning = /* GraphQL */ `
  subscription OnWinning {
    onWinning {
      username
      amount
      amountWinning
      valute
    }
  }
`;
